type PermissionValues = 'spread.individualDate';

export class SpreadPermission {
  public static readonly individualDate: PermissionValues =
    'spread.individualDate';
}
